export const GET_STATUS_SALE_PLANNING = `query GetStatusSalePlanning($input: TcodeWhereInput!){
    getCode(where: $input){
        items{
            id
            name
        }
    }
}
`;

export const VARIABLES_GET_STATUS_SALE_PLANNING = (groupId: any) => {
  return {
    input: {
      groupId: {
        equals: groupId,
      },
    },
  };
};
